export default {
  path: '/lvy-e-sign',
  component: () => import('./LVYESign'),
  meta: {
    title: '电子合同自动盖章法律效力确认函',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}